import api, { BASE_URL } from "../../api";

const SHOP_SETTINGS_BASE_URL = `${BASE_URL}/shop/admin/settings/`;
const SHOP_STATS_BASE_URL = `${BASE_URL}/shop/admin/stats/`;

const getTodayStats = context => {
  return api(context)
    .get(`${SHOP_STATS_BASE_URL}today/`)
    .then(response => response.data);
};

const listShopSettings = (context) => {
  return api(context)
    .get(SHOP_SETTINGS_BASE_URL)
    .then((response) => response.data);
};

const getShopSettings = (context, key) => {
  return api(context)
    .get(`${SHOP_SETTINGS_BASE_URL}${key}/`)
    .then((response) => response.data);
};

const updateShopSettings = (context, shopSettings) => {
  return api(context)
    .patch(
      `${SHOP_SETTINGS_BASE_URL}${shopSettings.key}/`,
      shopSettings
    )
    .then((response) => response.data);
};

const insertShopSettings = (context, shopSettings) => {
  return api(context)
    .post(SHOP_SETTINGS_BASE_URL, shopSettings)
    .then((response) => response.data);
};

export const shopSettings = {
  BASE_URL: SHOP_SETTINGS_BASE_URL,
  list: listShopSettings,
  get: getShopSettings,
  update: updateShopSettings,
  insert: insertShopSettings,
  stats: {
    getTodayStats
  }
};

export default shopSettings;
